export default {
  schedules(state) {
    return state.schedules
  },
  scheduleFilters(state) {
    return state.schedulePage.scheduleFilters
  },
  inputType(state) {
    return state.schedulePage.inputType
  },
  inputTemplate(state) {
    return state.schedulePage.inputTemplate
  },
  showModal(state) {
    return state.schedulePage.showModal
  },
  selectedItemData(state) {
    return state.schedulePage.selectedItemData
  },
  scheduleStatistic(state) {
    return state.scheduleStatistic
  },
}
